import { Component, Input } from '@angular/core';

@Component({
    selector: 'ms-texts-help',
    templateUrl: './texts-help.component.html',
    styleUrls: ['./texts-help.component.scss'],
    standalone: false
})
export class TextsHelpComponent {
  translateKey: string = '';

  @Input()
  public get transform(): string {
    return this._transform;
  }

  public set transform(value: string) {
    this._transform = value;
    this.translateKey = 'texts.parameters.transforms.' + value + '.info';
  }

  private _transform: string;
}
